export default {
  name: 'help-desk',
  header: "Mesa de Ayuda",
  children: [],
};
